export function passwordResetRedirectUrl(origin: string) {
  return new URL("/reset-password", origin).href;
}

export function newPasswordError(password: string, confirmation: string) {
  if (password.length < 8) {
    return "Password must contain at least 8 characters";
  }
  if (password !== confirmation) {
    return "Passwords do not match";
  }

  return null;
}
